module.exports = __webpack_public_path__ + "static/media/live15_06_2019.41e8709f.jpg";